module.exports = __webpack_public_path__ + "624c1255/img/35000000-4.5086066e.png";